(function () {
    'use strict';

    angular
        .module('Lavpop-store.services')
        .service('ProviderService', ProviderService)

    /** @ngInject */
    function ProviderService(HttpService) {
        const ProviderService = {
            getAll: getAll
        };

        return ProviderService;

        function getAll() {
            return HttpService.get('/providers/resumed');
        }
    }
}());